module.exports = __webpack_public_path__ + "img/nova-high-angle.e3588728.png";